import { CancellationTicket } from '../../../../../core';

export const cancellationTicket = {
    searchText: 'Buscar ticket',
    filter: false,
    checkbox: false,
    expandable: false,
    disabled: false,
    partialField: '',
    columns: [
        {
            title: 'Número de ticket',
            name: 'ticketNumber',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: CancellationTicket) => element.ticketNumber
        },
        {
            title: 'Fecha de anulación',
            name: 'cancellationDate',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: CancellationTicket) => element.cancellationDate
        },
        {
            title: 'Imprimir',
            type: 'button',
            name: 'printerTicket',
            editable: false,
            checkAll: false,
            class: 'left',
            value: () => {
              return {
                icon: 'printer',
                tooltip: 'Imprimir'
              };
            }
          }
    ]
};
